module.exports = __webpack_public_path__ + "static/media/zscalar-light.76ce9451.png";